import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../shadcn/Select";
import { sortingOptions } from "../../data/selectionData";
import { SORT_KEY_DELIMITER } from "../../constants/ui";

const SortBy = ({ value, onChange }) => {
  // Create a string key from the value object for comparison
  const getValueKey = (val) => {
    if (!val) return "";
    if (typeof val === 'string') return val;
    return `${val.sort}${SORT_KEY_DELIMITER}${val.sort_dir}`;
  };

  // Convert the current value to string key
  const currentValue = getValueKey(value);

  // Handle change by parsing the key back to object
  const handleChange = (key) => {
    const [sort, sort_dir] = key.split(SORT_KEY_DELIMITER);
    onChange({ sort, sort_dir });
  };

  return (
    <Select value={currentValue} onValueChange={handleChange}>
      <SelectTrigger>
        <SelectValue placeholder="Sort:" />
      </SelectTrigger>
      <SelectContent>
        {sortingOptions.map(({ name, value }) => {
          const key = `${value.sort}${SORT_KEY_DELIMITER}${value.sort_dir}`;
          return (
            <SelectItem key={key} value={key}>
              {name}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};

export default SortBy;